<template>
  <div>
    <div>
      <span>旧产品版本: </span>
      <el-select v-model="oldProductId" placeholder="请选择" filterable="true" style="width: 240px;margin-left: 13px;">
        <el-option v-for="(item, index) in productList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div style="margin-top: 10px;">
      <span>新产品版本: </span>
      <el-select v-model="newProductId" placeholder="请选择" filterable="true" style="width: 240px;margin-left: 13px;">
        <el-option v-for="(item, index) in productList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div style="text-align: center; margin-top: 20px;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { PRODUCT_MNG, CASE_MNG } from '@/api/apiModules'

export default {
  name: 'SkyUpdateOldToNewProduct',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    caseType: null
  },
  data() {
    return {
      productList: [],
      oldProductId: null,
      newProductId: null
    }
  },
  mounted() {
    this.newProductId = this.oldProductId
    action(PRODUCT_MNG, 'findAllActive').then(response => {
      this.productList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
  },
  computed: {},
  watch: {},
  methods: {
    onConfirm() {
      if (!this.oldProductId) {
        this.$store.dispatch('OpenNotification', { message: '请选择旧产品版本', type: 'error' })
        return
      }

      if (!this.newProductId) {
        this.$store.dispatch('OpenNotification', { message: '请选择新产品版本', type: 'error' })
        return
      }

      if (this.oldProductId === this.newProductId) {
        this.$store.dispatch('OpenNotification', { message: '新旧产品版本相同，无需升级', type: 'error' })
        return
      }

      const request = {
        oldProductId: this.oldProductId,
        newProductId: this.newProductId,
        caseType: this.caseType
      }

      this.rootView.loading = true
      action(CASE_MNG, 'batchUpdateProduct', request)
        .then(response => {
          this.$emit('cb')
        })
        .catch(e => {
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
